export default "__VITE_ASSET__C7qO2xkN__"